<script>
import { mapGetters } from 'vuex'

export default {
    name: "BaseAccountType",
    props: {
        accountType: {
            type: String,
        },
        accountCurrency: {
            type: String
        }
    },
    computed: {
        ...mapGetters(['staticBase'])
    },
    methods: {
        getAccountCLass(type) {
            switch (type.toLowerCase()) {
                case 'vip':
                    return 'vip'
                default:
                    return type
            }
        }
    }
}
</script>

<template>
    <div class="account-type">
        <div class="account-type__currency-img">
            <img 
                :key="accountCurrency"
                :src="`${staticBase}currencies/${accountCurrency}.png`" 
                :alt="accountCurrency" 
                @error="$event.target.style.display = 'none'"
            >
        </div>
        <div class="account-type__name" :class="getAccountCLass(accountType)">{{ accountType }} account</div>
    </div>
</template>

<style scoped>
.account-type {
    display: flex;
    align-items: center;
    gap: 8px;
}

.account-type__currency-img{
    min-width: 20px;
    max-width: 20px;
    min-height: 20px;
    max-height: 20px;
    img{
        width: 100%;
        height: 100%;
    }
}

.account-type__name{
    padding: 2px 6px;
    border-radius: 3px;
    background: var(--Statelayers-secondary-opacity08);
    color: var(--System-OnPrimaryContainer);
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 400;
}

.account-type__name.vip {
    background: linear-gradient(55deg, rgba(41, 151, 149, 0.30) 6.34%, rgba(58, 123, 204, 0.30) 97.55%);
}
</style>
